// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","mainSection":"G807b38","paddingElement":"Gcc5f5d","orderedList":"G853138","itemList":"G39b09e"};